import { render, staticRenderFns } from "./TheThgAboutList.vue?vue&type=template&id=9398a28a&scoped=true&"
import script from "./TheThgAboutList.vue?vue&type=script&lang=ts&"
export * from "./TheThgAboutList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9398a28a",
  null
  
)

export default component.exports